import { isDefined, safeRead, Terminable, Terminator } from "@opendaw/lib-std";
import { Browser } from "./browser";
import { AnimationFrame } from "./frames";
import { Events } from "./events";
import { Keyboard } from "./keyboard";
export var Dragging;
(function (Dragging) {
    Dragging.attach = (target, factory, options) => {
        const processCycle = new Terminator();
        return Terminable.many(processCycle, Events.subscribe(target, "pointerdown", (event) => {
            if (options?.multiTouch !== true && !event.isPrimary) {
                return;
            }
            if (event.buttons !== 1 || (Browser.isMacOS() && event.ctrlKey)) {
                return;
            }
            const option = factory(event);
            if (option.isEmpty()) {
                return;
            }
            const process = option.unwrap();
            const pointerId = event.pointerId;
            event.stopPropagation();
            event.stopImmediatePropagation();
            target.setPointerCapture(pointerId);
            const moveEvent = {
                clientX: event.clientX,
                clientY: event.clientY,
                altKey: event.altKey,
                shiftKey: event.shiftKey,
                ctrlKey: Keyboard.isControlKey(event)
            };
            if (options?.immediate === true) {
                process.update(moveEvent);
            }
            if (options?.permanentUpdates === true) {
                processCycle.own(AnimationFrame.add(() => process.update(moveEvent)));
                processCycle.own(Events.subscribe(target, "pointermove", (event) => {
                    if (event.pointerId === pointerId) {
                        moveEvent.clientX = event.clientX;
                        moveEvent.clientY = event.clientY;
                        moveEvent.altKey = event.altKey;
                        moveEvent.shiftKey = event.shiftKey;
                        moveEvent.ctrlKey = Keyboard.isControlKey(event);
                    }
                }));
            }
            else {
                processCycle.own(Events.subscribe(target, "pointermove", (event) => {
                    if (event.pointerId === pointerId) {
                        moveEvent.clientX = event.clientX;
                        moveEvent.clientY = event.clientY;
                        moveEvent.altKey = event.altKey;
                        moveEvent.shiftKey = event.shiftKey;
                        moveEvent.ctrlKey = Keyboard.isControlKey(event);
                        process.update(moveEvent);
                    }
                }));
            }
            const cancel = () => {
                process.cancel?.call(process);
                process.finally?.call(process);
                processCycle.terminate();
            };
            const owner = safeRead(target, "ownerDocument", "defaultView") ?? self;
            processCycle.ownAll(Events.subscribe(target, "pointerup", (event) => {
                if (event.pointerId === pointerId) {
                    process.approve?.call(process);
                    process.finally?.call(process);
                    processCycle.terminate();
                }
            }, { capture: true }), Events.subscribe(target, "pointercancel", (event) => {
                console.debug(event.type);
                if (event.pointerId === pointerId) {
                    target.releasePointerCapture(pointerId);
                    cancel();
                }
            }, { capture: true }), Events.subscribe(owner, "beforeunload", (_event) => {
                // Workaround for Chrome (does not release or cancel the pointer)
                target.releasePointerCapture(pointerId);
                cancel();
            }, { capture: true }), Events.subscribe(owner, "keydown", (event) => {
                moveEvent.altKey = event.altKey;
                moveEvent.shiftKey = event.shiftKey;
                moveEvent.ctrlKey = Keyboard.isControlKey(event);
                if (event.key === "Escape") {
                    cancel();
                }
                else {
                    process.update(moveEvent);
                }
            }), Events.subscribe(owner, "keyup", (event) => {
                moveEvent.altKey = event.altKey;
                moveEvent.shiftKey = event.shiftKey;
                moveEvent.ctrlKey = Keyboard.isControlKey(event);
                process.update(moveEvent);
            }));
            if (isDefined(process.abortSignal)) {
                processCycle.own(Events.subscribe(process.abortSignal, "abort", () => {
                    target.releasePointerCapture(pointerId);
                    cancel();
                }));
            }
        }));
    };
})(Dragging || (Dragging = {}));
